/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareLinkedEntity, userSupportedTypes } from '../fw/MetaDataHelper.ts';
import * as Permission from '../util/Permission';
import { ACCESS_TYPE_DEVELOPER, ACCESS_TYPE_PARTNER1, ACCESS_TYPE_PARTNER2, ACCESS_TYPE_REGULARUSER } from './UserType';

export default declareLinkedEntity({
    entity: "flowOptionDocDefs",
    graphQL: "FlowOptionDocDef",
    name: "Flow Option Doc Definition",
    defaultOrder: ['order', 'name'],
    writePermission: [
        Permission.PERM_EDIT_CHANNEL_DEF
    ],
    dynamoPrefix: 'def',
    storageType: 'schema',
    parentRelation: 'flowOptionDocDefs',
    defaultTitle: (data) => {
        return data['name'];
    },
    onModify: ['flowDef'],
    fields: (types) => { return {
        id: {
            name: "Flow Option Definition ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            compositeKey: true,
            userEditable: false,
        },
        flowDef: {
            name: "Flow Definition",
            type: "relation",
            to: () => types['flowDefs'],
            defaultValue: (flowDef) => {
                return flowDef['flowDef_id'];
            },
            required: true,
            compositeKey: true,
            hiddenCreate: true,
            relativeTo: ["flowDefVersion"],
        },
        flowOptionDef: {
            name: "Flow Option Definition",
            to: () => types['flowOptionDefs'],
            type: "relation",
            defaultValue: (flow) => {
                return flow['id'];
            },
            required: true,
            parent: true,
            hiddenCreate: true,
            compositeKey: true,
            relativeTo: ["flowDefVersion", "flowDef"],
        },
        flowDefVersion: {
            name: "Flow Definition Version",
            to: () => types['flowDefVersions'],
            type: "relation",
            defaultValue: (flow) => {
                return flow['flowDefVersion_id'];
            },
            hiddenCreate: true,
            compositeKey: true,
        },
        name: {
            name: "Name",
            type: "string",
            trim: true,
            translatable: true,
            defaultValue: "",
        },
        description: {
            name: "Description",
            type: "text",
            translatable: true,
            defaultValue: ""
        },
        longDescription: {
            name: "Long Description",
            type: "html",
            translatable: true,
            defaultValue: ""
        },
        datiQuery: {
            name: "DatiQuery",
            type: "string",
            descriptionHtml: "<small>Example: <pre>SELECT current.\"com.dativery.model.sharedFields.code@code\" as code, current.\"com.dativery.model.sharedFields.name@name\" as label FROM [APP $CURRENT TYPE \"eu.flexibee.c\"] as current</pre></small>",
        },
        examples: {
            name: "Examples",
            type: "string",
            translatable: true,
            trim: true,
            defaultValue: "",
            visibility: (data) => { return data['type'] !== 'form'; }
        },
        defaultValue: {
            name: "Default Value",
            type: "string",
            translatable: true,
            trim: true,
            defaultValue: "",
            visibility: (data) => { return data['type'] !== 'form'; }
        },
        defaultValueForExisting: {
            name: "Default Value for existing flows",
            type: "string",
            translatable: true,
            trim: true,
            defaultValue: "",
            visibility: (data) => { return data['type'] !== 'form'; }
        },
        channelDef: {
            name: "Channel Definition",
            type: "relation",
            to: () => types['channelDefs'],
            required: true,
        },
        author: {
            name: "Author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        }
    }; },
    relations: (types) => { return {
        flowStepLinkDefs: {
            type: 'oneToMany',
            to: types['flowStepLinkDefs'],
            export: true,
            defaultValue: () => {
                return {};
            },
        },
    }}
});

export const FLOW_OPTION_DEF_OPTIONS_KEY = 'flowOptionDefs';
